import { Typography } from "@mui/material";

interface PaginationInfoProps {
  startItem: number;
  endItem: number;
  totalCount: number;
}

const PaginationInfo = ({ startItem, endItem, totalCount }: PaginationInfoProps) => {
  return (
    <Typography variant="p3">
      {`${startItem}-${endItem} из ${totalCount}`}
    </Typography>
  );
};

export default PaginationInfo;
